import React from 'react';
import { motion } from 'framer-motion';
const HEADSHOT_URL = 'https://cdn.magicpatterns.com/patterns/generated-images/dc03cda3-cf07-410f-8652-902878c04bf9.jpg';
export function Hero() {
  return <section id="hero" className="relative bg-navy pt-40 pb-20 lg:pt-48 lg:pb-28" data-id="element-117" data-mp="9k0eb6ruedp4">
      <div className="max-w-content mx-auto px-6 lg:px-10 flex flex-col items-center text-center" data-id="element-118" data-mp="4lyx6rdz8oga">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-56 sm:w-64" data-id="element-119" data-mp="1297aw07qkt7q">
          <span className="absolute -top-3 -left-3 h-8 w-8 border-t-2 border-l-2 border-gold" aria-hidden="true" data-id="element-120" data-mp="s9zybf8tt2lo" />
          <span className="absolute -top-3 -right-3 h-8 w-8 border-t-2 border-r-2 border-gold" aria-hidden="true" data-id="element-121" data-mp="nbosdflnjc8q" />
          <span className="absolute -bottom-3 -left-3 h-8 w-8 border-b-2 border-l-2 border-gold" aria-hidden="true" data-id="element-122" data-mp="3czfme2gnud7m" />
          <span className="absolute -bottom-3 -right-3 h-8 w-8 border-b-2 border-r-2 border-gold" aria-hidden="true" data-id="element-123" data-mp="3j8iwsycd6eu6" />
          <div className="border border-gold/70 bg-navy-light p-2.5" data-id="element-124" data-mp="3o85a17s6zv2z">
            <img src={HEADSHOT_URL} alt="Portrait of Stephanie Meyer" className="w-full aspect-[4/5] object-cover" data-id="element-125" data-mp="3o59chkk9b8f2" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.23, 1, 0.32, 1],
        delay: 0.15
      }} className="mt-10 max-w-3xl" data-id="element-126" data-mp="30i19xae7qdgq">
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white" data-id="element-127" data-mp="2qkmtvbw7bqoy">
            Stephanie Meyer
          </h1>
          <div className="mt-5 mx-auto h-[3px] w-16 bg-gold" data-id="element-128" data-mp="2vgtx2wx7qo37" />
          <p className="mt-6 text-base sm:text-lg leading-relaxed text-slate-300" data-id="element-129" data-mp="2hkgj3xrw14th">
            International Executive | Board Director | EVP, Broadcasting Worldwide | Commercial
            Transformation &amp; Growth Leadership
          </p>
          <p className="mt-6 text-sm sm:text-[15px] text-slate-400 tracking-wide" data-id="element-130" data-mp="s3usu27hfid9">
            Luxembourg&nbsp;&nbsp;|&nbsp;&nbsp;stephanie.meyer@totalmedia.lu&nbsp;&nbsp;|&nbsp;&nbsp;+352 621 253 609
          </p>

          <div className="mt-10" data-id="element-131" data-mp="ddf5agrlfybx">
            <a href="#contact" className="inline-flex items-center justify-center bg-gold px-8 py-3.5 text-sm font-semibold tracking-wide text-navy hover:bg-gold-light transition-colors duration-200" data-id="element-132" data-mp="degfkj0scgsl">
              Submit a Board Inquiry
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}